import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
const initState = {
    _loop: 0,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         * @desc 主动获取大屏详情接口
         * @argument 轮询时长 400ms
         */
        loop(payload, { update, state, rootState }) {
            console.log('直接使用轮询接口');
            this.CLEAR__LOOP();
            const _loop = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                dispatch.screen.load({});
                this.loop({});
            }), 800);
            this.SET__LOOP(_loop);
        },
        /**
         * @desc 关闭轮询
         */
        stopLoop() {
            console.log('关闭轮询');
            this.CLEAR__LOOP();
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SET__LOOP(state, payload) {
            state._loop = payload;
        },
        CLEAR__LOOP(state) {
            clearTimeout(state._loop);
            state._loop = 0;
        },
    },
});
